export const DEFAULT_APP = '/public/trade'
export const TRADE_INSPIRATION_APP = '/public/wpCms/wpNoPromo'
export const ART_ADVISORY_APP = 'public/quiz/artAdvisory'
export const DEFAULT_URL = '/trade'
export const LANDING_HERO_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/hero.jpg'
export const HOSPITALITY_HERO_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/whysell/get-featured.jpg'
export const BENEFIT_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/trade/benefits/benefit-image.jpg'
export const EMERGING_ARTIST_IMAGE =
  '//d3t95n9c6zzriw.cloudfront.net/trade/home/emerging-artist.jpg'
export const AA_SERVICES_IMAGE =
  '//d3t95n9c6zzriw.cloudfront.net/trade/capabilities/aa-services.jpg'
export const ONE_HOTEL_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/trade/capabilities/1hotel-image.jpg'
export const FOUR_SEASONS_IMAGE =
  '//d3t95n9c6zzriw.cloudfront.net/trade/capabilities/four-seasons.jpg'
export const FORBES_IMAGE = '//d3t95n9c6zzriw.cloudfront.net/trade/capabilities/forbes.jpg'
export const TRAVEL_AND_LEISURE_IMAGE =
  '//d3t95n9c6zzriw.cloudfront.net/trade/capabilities/travel-and-leisure.jpg'
export const SECTION = 'trade'
export const LANDING = 'landing'
export const COMMERCIAL = 'commercial'
export const HEALTHCARE = 'healthcare'
export const HOSPITALITY = 'hospitality'
export const RESIDENTIAL = 'residential'
export const CAPABILITIES = 'capabilities'
export const HERO_DATA = {
  [LANDING]: {
    title: 'Art Advisory for Trade',
    subTitle:
      'Inspire your clients with original Art, Prints, and Custom Installations from the world’s leading online gallery.',
    site: 'Landsby',
    location: 'Mountain View, CA',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/hero/landing-hero-2023.jpg',
    height: '718',
  },
  [HOSPITALITY]: {
    title: 'Hospitality Art Advisory',
    site: 'Life House Hotel',
    location: 'Denver, COLORADO',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/hero/hospitality-hero-2023.jpg',
    photoCourtesy: 'Photo courtesy of Matt Kindsay for Life House',
    height: '519',
  },
  [COMMERCIAL]: {
    title: 'Commercial Art Advisory',
    site: 'Anatomē',
    location: 'London, UK',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/hero/commercial-hero-2023.jpg',
    height: '519',
  },
  [HEALTHCARE]: {
    title: 'Healthcare Art Advisory',
    site: 'Shirley Ryan Ability Lab',
    location: 'Chicago, IL',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/hero/healthcare-hero-2023.jpg',
    height: '519',
  },
  [RESIDENTIAL]: {
    title: 'Residential & Multi-Family Art Advisory',
    site: 'Faraday Park East',
    location: 'Reston, VA',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/hero/residential-hero-2023.jpg',
    height: '519',
  },
  [CAPABILITIES]: {
    title: 'Our Capabilities',
    site: 'Life House Hotel',
    location: 'Denver, CO',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/hero/capabilities-hero-2023.jpg',
    photoCourtesy: 'Photo courtesy of Matt Kindsay for Life House',
    height: '519',
  },
}
export const WHY_SAATCHI_DATA = {
  [LANDING]: `Saatchi Art provides complimentary and comprehensive art advisory services for designers, trade associates, corporations, and institutions. We partner with you to find outstanding artworks for your clients, while also helping you meet budget and overall design concept goals. When you work with us, you will benefit from high-end curation, access to artists all over the globe, and an unparalleled range of fabrication possibilities.`,
  [COMMERCIAL]: `Every aspect of a business helps to shape its identity. The right art can foster the community, creativity, and inspiration needed to set your brand apart in today's highly-competitive world. Our Art Advisory team can work with you to ensure your curated art program meets desired financial and functional outcomes, while enhancing the overall plan for your space. We have deep experience curating art for business headquarters, food and beverage, retail, educational spaces, and more.`,
  [HEALTHCARE]: `Research shows that the artwork displayed in healthcare and senior living facilities can not only support well-being, but also foster stronger connections between patients, residents, and staff. Following findings from evidence-based design, our senior art advisors can help you procure artworks that create healing environments without distracting from the important work of recovery and wellness.`,
  [HOSPITALITY]: `Whether you oversee the design of a boutique property or an international hotel brand, your most important priority is creating an unforgettable guest experience. Our expert advisors will help you discover art from an unparalleled inventory of original works or commission artists to create custom pieces tailored to your project and brand.`,
  [RESIDENTIAL]: `Saatchi Art can help you select artworks to complement and enhance your vision, whether you're looking for a single statement piece or an entire collection. We work directly with emerging artists from over 110 countries, who can produce work to suit all budgets, styles, and spaces. We're happy to manage the process from beginning to end, including artwork selection, as well as offering advice on framing and facilitating installation.`,
  [CAPABILITIES]: `From cruise ships and luxury resorts to corporate headquarters and healthcare facilities, Saatchi Art provides specialized art advisory services for the world's most respected brands, corporations, and organizations to suit their unique needs. Our comprehensive process puts the client and their story front-and-center to deliver art programming that will enhance their space and showcase their creative vision effectively and efficiently.`,
}
export const SERVICES_DATA = [
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/services/hospitality-thumb.jpg',
    title: 'Hospitality',
    url: '/trade/hospitality',
    section: 'hospitality',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/services/commercial-thumb.jpg',
    title: 'Commercial',
    url: '/trade/commercial',
    section: 'commercial',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/services/healthcare-thumb.jpg',
    title: 'Healthcare',
    url: '/trade/healthcare',
    section: 'healthcare',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/services/residential-thumb.jpg',
    title: 'Residential & Multi-Family',
    url: '/trade/residential',
    section: 'residential',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/services/privatecollector-thumb.jpg',
    title: 'Private Collector',
    url: '/artadvisory',
    section: 'artadvisory',
  },
]
export const PROCESS_DATA = [
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/process/concept-image.jpg',
    title: 'Concept',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/process/process-image.jpg',
    title: 'Fabrication',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/process/installation-image.jpg',
    title: 'Installation',
  },
]
export const CASE_STUDY_CAROUSEL_DATA = [
  '//d3t95n9c6zzriw.cloudfront.net/trade/inspiration/frame1-image.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/trade/inspiration/frame2-image.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/trade/inspiration/frame3-image.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/trade/inspiration/frame4-image.jpg',
]
export const CLIENT_DATA = [
  {
    title: 'slide 1',
    images: [
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-fourseasons-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-dream-hotel-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-hilton-garden-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-hyatt-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-jw-marriott-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-marriott-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-mgm-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-nobu-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-royal-caribbean-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-viking-desk.jpg',
    ],
  },
  {
    title: 'slide 2',
    images: [
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-renaissance-hotels-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-baker-mckenzie-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-parrot-key-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-naples-grande-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-lifehouse-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-graduate-hotels-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-line-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-19-dutch-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-brookfield-properties-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-intercontinental-desk.jpg',
    ],
  },
  {
    title: 'slide 3',
    images: [
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-amavida-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-fairmont-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-st-gregory-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-ruths-chris-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-breakers-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-sandals-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-executive-hotels-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-autograph-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-embassy-suites-desk.jpg',
      '//d3t95n9c6zzriw.cloudfront.net/trade/clients/clients-crowne-plaza-desk.jpg',
    ],
  },
]
export const CASE_STUDY_DATA = {
  [HOSPITALITY]: {
    site: 'Four Seasons New Orleans',
    award: 'Winner for Best Luxury Guestroom, HD Awards 2022',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/case-study/hospitality-case-study-2023.jpg',
    text: `Saatchi Art worked with Bill Rooney Studio to integrate artwork into each of the property's 330 guest rooms. The stand-out artwork is an intricately carved custom sculptural panel inspired by photographs of flora native to the area, which is showcased over each bed.`,
    url: '/trade-inspiration/trade-case-study-four-seasons-new-orleans',
  },
  [COMMERCIAL]: {
    site: 'Roc Nation',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/case-study/commercial-case-study-2023.jpg',
    text: `Working closely with Roc Nation’s CEO Desiree Perez, Saatchi Art art advisors helped to add new high-impact works to the art collection on display at the sleek, collaborative, six-floor working space designed by Jeffrey Beers International.`,
    url: '/trade-inspiration/trade-case-study-roc-nation',
  },
  [HEALTHCARE]: {
    site: 'Shirley Ryan Ability Lab',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/case-study/healthcare-case-study-2023.jpg',
    text: `Shirley Ryan AbilityLab prioritizes art as part of the rehabilitation process and through their collection they seek to create an immediate emotional connection. For the project, Saatchi Art curated a diverse collection of uplifting and imaginative artworks by an international roster of over 130 emerging artists.`,
    url: '/trade-inspiration/trade-case-study-shirley-ryan-abilitylab/',
  },
  [RESIDENTIAL]: {
    site: 'Lilia Waikiki',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/case-study/residential-case-study-2023.jpg',
    text: `Nestled in the exciting downtown of Honolulu, the stunning 28-story residential tower features artwork from Hawaii-based artists and images of local flora and fauna throughout the property, hand-selected by Saatchi Art curators.`,
    url: '/trade-inspiration/trade-case-study-lilia-waikiki/',
  },
}
export const SUB_MENU_DATA = [
  {
    title: 'Art Advisory for Trade',
    url: '/trade-hospitality',
    page: '',
  },
  {
    title: 'Our Capabilities',
    url: '/trade/capabilities',
    page: 'capabilities',
  },
  {
    title: 'Commercial',
    url: '/trade/commercial',
    page: 'commercial',
  },
  {
    title: 'Hospitality',
    url: '/trade/hospitality',
    page: 'hospitality',
  },
  {
    title: 'Healthcare',
    url: '/trade/healthcare',
    page: 'healthcare',
  },
  {
    title: 'Residential & Multi-Family',
    url: '/trade/residential',
    page: 'residential',
  },
  {
    title: 'Case Studies & More',
    url: '/trade-inspiration',
    page: 'trade-inspiration',
  },
]